import ActionType from 'actions/ActionType'

export default (state = null, action) => {
  switch (action.type) {
    case ActionType.Inbox.SELECT_CONVERSATION:
      return null
    case ActionType.Inbox.SELECT_NEW_CONVERSATION:
      return action.payload
    case ActionType.Inbox.SELECT_CONTACT:
      return null
    case '@@router/LOCATION_CHANGE':
      return null
    case ActionType.Data.LIST_SUCCESS:
      if (action.entityType === 'inbox') {
        return Array.isArray(action.payload) && action.payload.find(
          (conversation) => conversation.contact_id === state,
        )
          ? null
          : state
      }
      return state
    case ActionType.Inbox.SEND_SMS:
      if (action.payload && action.payload.contactSelected) {
        return action.payload.contact_id
      }
      return state
    case ActionType.Email.SEND_REQUEST:
      if (action.extraData && action.extraData.contactSelected) {
        return action.extraData.contact_id
      }
      return state
    default:
      return state
  }
}
